var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriteReviewImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.222,
    height: 25.18,
    viewBox: "0 0 22.222 25.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49750",
    "data-name": "Group 49750",
    transform: "translate(3737 7004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44714",
    "data-name": "Path 44714",
    d: "M19.673,4.849a.244.244,0,0,0-.221-.205c-.091-.008-1.884-.035-1.884-.035s-1.5-1.456-1.647-1.6a.612.612,0,0,0-.55-.07l-.753.233a5.279,5.279,0,0,0-.36-.886A2.539,2.539,0,0,0,12,.723h0c-.066,0-.131.006-.2.012-.028-.034-.056-.066-.085-.1A1.979,1.979,0,0,0,10.141,0c-1.22.035-2.435.916-3.42,2.481a9.823,9.823,0,0,0-1.37,3.555l-2.4.744c-.707.222-.729.244-.822.91C2.06,8.195.21,22.5.21,22.5l15.5,2.681,6.719-1.67S19.69,4.976,19.673,4.849Zm-5.831-1.44-1.2.372a6.662,6.662,0,0,0-.37-2.219C13.194,1.736,13.65,2.784,13.842,3.408Zm-2.014.624-2.588.8A6.135,6.135,0,0,1,10.546,2.3a2.611,2.611,0,0,1,.879-.64A5.817,5.817,0,0,1,11.828,4.032ZM10.166.813a1.244,1.244,0,0,1,.734.192,3.53,3.53,0,0,0-.947.738A7.107,7.107,0,0,0,8.347,5.109l-2.126.658C6.641,3.808,8.283.867,10.166.813Z",
    transform: "translate(-3737.21 -7004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44715",
    "data-name": "Path 44715",
    d: "M34.229,7.417c-.091-.008-1.884-.035-1.884-.035s-1.5-1.456-1.647-1.6a.366.366,0,0,0-.208-.1v22.27l6.718-1.67S34.467,7.75,34.45,7.622A.245.245,0,0,0,34.229,7.417Z",
    transform: "translate(-3751.987 -7006.773)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44716",
    "data-name": "Path 44716",
    d: "M15.925,15.565l-.78,2.919a4.432,4.432,0,0,0-1.9-.331c-1.513.1-1.529,1.05-1.514,1.29.082,1.306,3.517,1.591,3.71,4.649.152,2.406-1.276,4.052-3.334,4.182a5,5,0,0,1-3.829-1.3L8.8,24.748a4.736,4.736,0,0,0,2.464.963.968.968,0,0,0,.945-1.039c-.108-1.7-2.9-1.6-3.081-4.4-.149-2.355,1.4-4.741,4.81-4.956A4.2,4.2,0,0,1,15.925,15.565Z",
    transform: "translate(-3741.147 -7011.467)",
    fill: "#025344"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteReviewImg);
export default __webpack_public_path__ + "static/media/write-review-img.5f4319fde25af501841a10ff0f0c3104.svg";
export { ForwardRef as ReactComponent };